import { createInvoiceListContainer } from './container'
import { InvoiceList as InvoiceListUI } from './ui/invoice-list'

export const InvoiceListPage = createInvoiceListContainer(InvoiceListUI)
